export { default as RatingStars } from './RatingStars';
export type { RatingStarsProps } from './RatingStars';
